// extracted by mini-css-extract-plugin
export default {"component":"monthlyInfoRoot__component___tvMNG"};